import { createStore, applyMiddleware } from 'redux'
import rootReducer from './rootReducer';
import thunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';

const middlewareEnhancer = applyMiddleware(thunk)

const store = createStore(rootReducer, composeWithDevTools(middlewareEnhancer))

export default store